<script lang="ts">
  import MagicExchangeIcon from '@/ui/base/icon/gen/MagicExchange.svelte';

  let { size = 4, class: className, ...rest } = $props();
</script>

<MagicExchangeIcon {...rest} {size} class={`animate-loading ${className}`} />
